$(document).on('click', '#epd-user-gln-number-check', function () {
    if($(this).is(':checked')){
        Livewire.dispatch('clearRequestGfpNrForm');
    }else{
        Livewire.dispatch('clearGlnNumber');
    }
});

$(document).on('change','#epd-user-role',function () {
    if($(this).val() === 'gfp'){
        Livewire.dispatch('clearAssignmentToGfp');
    } else if($(this).val() === 'hip'){
        Livewire.dispatch('clearAssignmentToGroup');
    }
});

$(document).on('change','#epd-user-gln-number-request-check', function () {
    if($(this).val() == 0){
        Livewire.dispatch('clearRequestGfpNrForm');
    }
});

$(document).on('change','#epd-user-customer', function () {
    const customer_id = $(this).val();
    Livewire.dispatch('refreshEpdGroups', { customer_id: customer_id });
})
